import { render, staticRenderFns } from "./sncModal.vue?vue&type=template&id=3a2ffa3a"
import script from "./sncModal.vue?vue&type=script&lang=js"
export * from "./sncModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports